import 'babel-polyfill';
import fromEntries from 'object.fromentries';
import arrayFlat from 'array.prototype.flat';

if (!Object.fromEntries) {
    fromEntries.shim();
}

if (!Array.prototype.flat) {
    arrayFlat.shim();
}

if ( !HTMLFormElement.prototype.reportValidity ) {
    HTMLFormElement.prototype.reportValidity = function() {
        var submitButtons = this.querySelectorAll( "button, input[type=submit]" );
        for ( var i = 0; i < submitButtons.length; i++ ) {
            // Filter out <button type="button">, as querySelectorAll can't
            // handle :not filtering
            if ( submitButtons[ i ].type === "submit" ) {
                submitButtons[ i ].click();
                return;
            }
        }
    }
}

if (!('scrollIntoView' in document.documentElement)) {
    Element.prototype.scrollIntoView = function() {
        const start = window.pageYOffset;
        const end = this.getBoundingClientRect().top + start;
        const duration = 300; // Scroll duration in milliseconds
        const startTime = performance.now();

        function scrollStep(timestamp) {
            const currentTime = timestamp - startTime;
            const progress = currentTime / duration;
            const position = start + ((end - start) * progress);

            window.scrollTo(0, position);

            if (currentTime < duration) {
                requestAnimationFrame(scrollStep);
            }
        }

        requestAnimationFrame(scrollStep);
    }
};